import { Instagram, Facebook, Twitter, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { useNavigate, useLocation } from "react-router-dom";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://instagram.com", testid: "social-instagram" },
  { icon: Facebook, label: "Facebook", href: "https://facebook.com", testid: "social-facebook" },
  { icon: Twitter, label: "X", href: "https://x.com", testid: "social-twitter" },
  { icon: Mail, label: "Email", href: "mailto:circle@locka.maison", testid: "social-email" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (to) => {
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => window.__lenis?.scrollTo(`#${id}`, { offset: -80 }), 350);
      } else {
        window.__lenis?.scrollTo(`#${id}`, { offset: -80 });
      }
    } else {
      navigate(to);
    }
  };

  return (
    <footer className="border-t border-navy/10 bg-cream" data-testid="site-footer">
      <div className="mx-auto max-w-[1500px] px-6 pb-10 pt-20 md:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-xs font-serif text-2xl italic leading-snug text-navy/75" data-testid="footer-catchphrase">
              Locka — Where Every Step is Couture.
            </p>
            <div className="mt-8 flex gap-3" data-testid="footer-socials">
              {SOCIALS.map(({ icon: Icon, label, href, testid }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={testid}
                  className="flex h-11 w-11 items-center justify-center rounded-full border border-navy/15 text-navy transition-colors duration-300 hover:border-burgundy hover:bg-burgundy hover:text-cream"
                >
                  <Icon className="h-[18px] w-[18px]" strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="mb-6 text-[0.65rem] font-bold uppercase tracking-[0.3em] text-burgundy">The Collection</p>
            <ul className="space-y-3.5 text-sm text-navy/70">
              <li><button data-testid="footer-shop-all" onClick={() => go("/shop")} className="transition-colors duration-200 hover:text-burgundy">All Socks</button></li>
              <li><button data-testid="footer-shop-vintage" onClick={() => go("/shop?c=classic-vintage")} className="transition-colors duration-200 hover:text-burgundy">Classic Vintage</button></li>
              <li><button data-testid="footer-shop-luxe" onClick={() => go("/shop?c=modern-luxe")} className="transition-colors duration-200 hover:text-burgundy">Modern Luxe</button></li>
              <li><button data-testid="footer-shop-limited" onClick={() => go("/shop?c=limited-edition")} className="transition-colors duration-200 hover:text-burgundy">Limited Editions</button></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="mb-6 text-[0.65rem] font-bold uppercase tracking-[0.3em] text-burgundy">Maison</p>
            <ul className="space-y-3.5 text-sm text-navy/70">
              <li><button data-testid="footer-story" onClick={() => go("/#story")} className="transition-colors duration-200 hover:text-burgundy">Our Story</button></li>
              <li><button data-testid="footer-lookbook" onClick={() => go("/#lookbook")} className="transition-colors duration-200 hover:text-burgundy">Lookbook</button></li>
              <li><button data-testid="footer-circle" onClick={() => go("/#circle")} className="transition-colors duration-200 hover:text-burgundy">The Circle</button></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="mb-6 text-[0.65rem] font-bold uppercase tracking-[0.3em] text-burgundy">Care</p>
            <ul className="space-y-3.5 text-sm text-navy/70">
              <li className="leading-relaxed">Cold wash, inside out. Air dry. Love forever.</li>
              <li><button data-testid="footer-admin" onClick={() => go("/admin")} className="text-navy/40 transition-colors duration-200 hover:text-burgundy">Atelier Login</button></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-navy/10 pt-8 text-[0.62rem] font-semibold uppercase tracking-[0.26em] text-navy/40">
          <span>© MMXXVI Locka Maison de Chaussettes</span>
          <span>Como · Paris · New York</span>
        </div>
      </div>
    </footer>
  );
};
